import React, { useState, useEffect } from "react";
import Pending from "./Pending";
import Approved from "./Approved";
import { checkFirstLevelApproverPermission } from "services/utils/HelperFunction";
import { ApplyLeave } from "./ApplyLeave";
import LeavesCard from "./LeaveRequest";
import { showToast } from "services/utils/Status";
import { themes, defaultAllSelection } from "services/constants";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import "react-toastify/dist/ReactToastify.css";
import { useSelector, useDispatch } from "react-redux";
import { useFetch } from "services/hooks/useFetch";
import * as Mui from "@mui/material";
import { CustomAutoComplete } from "components/CustomComponents/CustomAutoComplete";
import { CustomAutoCompleteWithLogo } from "components/CustomComponents/CustomAutoCompleteWithLogo";
import {
  setDepartmentId,
  setDepartmentName,
} from "services/Redux/userManagament";
import sessionHandling from "services/utils/notificationUtils";
import DefaultMonthDateRangePicker from "../DateRangePicker";
import moment from "moment";

export const Leaves = () => {
  const dispatch = useDispatch();
  const {
    domain,
    token,
    userDetails,
    globalSearchValue,
    userScreenAccess,
    topbarCompanyId,
  } = useSelector((state) => state.tokenReducer);
  const { departmentId, departmentName } = useSelector(
    (state) => state.userReducer
  );
  const [departmentData, setDepartmentData] = useState([]);
  const [selectedComponent, setSelectedComponent] = React.useState("pending");
  const [pendingdata, setPendingData] = React.useState(null);
  const [loading, setLoading] = React.useState(true);
  const [updateLeaveCard, setUpdateLeaveCard] = useState(true);
  const [masterDataForSearch, setMasterDataForSearch] = useState([]);
  const [reloadApprovedData, setReloadApprovedData] = useState(false);
  const [reloadRejectedData, setReloadRejectedData] = useState(false);
  const [alignment, setAlignment] = useState("Approve");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [userName, setUserName] = useState("All");
  const [userId, setUserId] = useState(defaultAllSelection);
  const [showAutoCompleteAvathar, setShowAutoCompleteAvathar] = useState(false);
  const { result: membersData, setLoad: reCallMemberApi } = useFetch(
    `${domain}get-department-based-user/?department_id=${departmentId}&user_id=${userDetails.id}`
  );

  const handleChange = (event, newAlignment) => {
    if (newAlignment) {
      setAlignment(newAlignment);
    }
  };

  useEffect(() => {
    dispatch(setDepartmentName("All"));
    dispatch(setDepartmentId(99999));
  }, [dispatch]);

  useEffect(() => {
    const fetchDepartmentData = async () => {
      try {
        const response = await fetch(
          `${domain}get-department/?user_id=${userDetails.id}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `token ${token}`,
            },
          }
        );
        const res = await response.json();
        if (response.ok) {
          const allDepartment = {
            id: defaultAllSelection,
            department_name: "All",
          };
          setDepartmentData([allDepartment, ...res]);
        } else if (response.status === 409) {
          sessionHandling();
        } else {
          throw new Error(res.error);
        }
      } catch (error) {
        showToast("error", error.message);
      }
    };
    fetchDepartmentData();
  }, [domain, token, userDetails.id]);

  React.useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const leaveApi = `${domain}leave-request/?user_id=${userDetails.id}&status=Pending&department_id=${departmentId}&company_id=${topbarCompanyId}`;
        const response1 = await fetch(leaveApi, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `token ${token}`,
          },
        });

        const res1 = await response1.json();
        if (response1.ok) {
          const totalData = res1;
          totalData?.sort(
            (a, b) =>
              new Date(b?.from_date.split("-").reverse().join("-")) -
              new Date(a?.from_date.split("-").reverse().join("-"))
          );
          setPendingData(totalData);
          setMasterDataForSearch(totalData);
        } else {
          if (!response1.ok) {
            if (response1.status === 409) {
              sessionHandling();
            } else {
              throw new Error(res1.error);
            }
          }
        }
      } catch (error) {
        showToast("error", error.message);
      } finally {
        setLoading(false);
      }
    };
    if (selectedComponent === "pending") {
      fetchData();
    }
  }, [
    departmentId,
    domain,
    selectedComponent,
    token,
    topbarCompanyId,
    userDetails.id,
    userDetails.type,
  ]);

  const handleApproveClick = (item) => {
    const { id } = item;
    setPendingData((prevData) => {
      const updatedData = prevData.filter((item) => item.id !== id);
      return updatedData;
    });
  };

  const renderComponent = () => {
    switch (selectedComponent) {
      case "approved":
        return (
          <Approved
            setReloadApprovedData={setReloadApprovedData}
            reloadApprovedData={reloadApprovedData}
            userId={userId}
            startDate={startDate}
            endDate={endDate}
          />
        );
      case "rejected":
        return (
          <ApplyLeave
            setReloadRejectedData={setReloadRejectedData}
            reloadRejectedData={reloadRejectedData}
          />
        );
      case "pending":
        return (
          <Pending
            data={pendingdata}
            loading={loading}
            onApproveClick={handleApproveClick}
            setUpdateLeaveCard={setUpdateLeaveCard}
            masterDataForSearch={masterDataForSearch}
          />
        );
      default:
        break;
    }
  };

  useEffect(() => {
    const FilterDockets = () => {
      const cols =
        masterDataForSearch[0] && Object.keys(masterDataForSearch[0]);
      return masterDataForSearch?.filter((r) =>
        cols.some((c) =>
          r[c]
            ? r[c]
                .toString()
                .toLowerCase()
                .indexOf(globalSearchValue.toString().toLowerCase()) > -1
            : null
        )
      );
    };
    setPendingData(FilterDockets());
  }, [globalSearchValue, masterDataForSearch]);

  const updateUserName = (event, data) => {
    if (data) {
      setUserName(data);
      setUserId(data.user_id);
      reCallMemberApi(true);
      setShowAutoCompleteAvathar(false);
      if (selectedComponent === "approved") {
        setReloadApprovedData(true);
      } else if (selectedComponent === "rejected") {
        setReloadRejectedData(true);
      } else if (selectedComponent === "pending") {
        setUpdateLeaveCard(true);
      }
    } else {
      setShowAutoCompleteAvathar(true);
    }
  };

  const updateDepartmentName = (event, data) => {
    if (data) {
      dispatch(setDepartmentName(data.label));
      dispatch(setDepartmentId(data.id));
      localStorage.setItem("approveLeaveDepartmentId", data.id);
      localStorage.setItem("approveLeaveDepartmentName", data.label);
      setUserName("All");
      setUserId(defaultAllSelection);
      reCallMemberApi(true);
      if (selectedComponent === "approved") {
        setReloadApprovedData(true);
      } else if (selectedComponent === "rejected") {
        setReloadRejectedData(true);
      } else if (selectedComponent === "pending") {
        setUpdateLeaveCard(true);
      }
    }
  };

  const handleStartDate = async (startDate, endDate) => {
    setStartDate(
      moment(new Date(startDate.split("/").reverse().join("-"))).format(
        "YYYY-MM-DD"
      )
    );
    setEndDate(
      moment(new Date(endDate.split("/").reverse().join("-"))).format(
        "YYYY-MM-DD"
      )
    );
    reCallMemberApi(true);
    if (selectedComponent === "approved") {
      setReloadApprovedData(true);
    } else if (selectedComponent === "rejected") {
      setReloadRejectedData(true);
    } else if (selectedComponent === "pending") {
      setUpdateLeaveCard(true);
    }
  };

  return (
    <div className="flex flex-col items-center justify-center">
      <Mui.Grid container sx={{ paddingTop: 5, paddingLeft: 3 }}>
        <Mui.Grid xs={4.4}>
          <Mui.Box
            sx={{
              display: "flex",
              alignItems: "center",
              width: 500,
              height: 55,
              position: "relative",
              overflow: "hidden",
            }}
          >
            <ToggleButtonGroup
              value={alignment}
              exclusive
              onChange={handleChange}
              sx={{
                display: "flex",
                width: "100%",
                height: "100%",
                position: "absolute",
                borderRadius: "30px",
                backgroundColor: themes.lightBrown,
              }}
            >
              <ToggleButton
                value="Approve"
                sx={{
                  flex: 1,
                  textTransform: "capitalize",
                  fontSize: 18,
                  borderRadius: "30px",
                  fontWeight: 600,
                  border: "none",
                  color:
                    alignment === "Approve"
                      ? themes.whiteColor
                      : themes.headLine,
                  backgroundColor:
                    alignment === "Approve"
                      ? themes.headLine
                      : themes.lightBrown,
                  "&.Mui-selected": {
                    backgroundColor: themes.headLine,
                    color: themes.whiteColor,
                    "&:hover": {
                      backgroundColor: themes.headLine,
                      color: themes.whiteColor,
                    },
                    borderRadius: "30px",
                    "&.Mui-selected": {
                      borderRadius: "30px",
                    },
                  },
                  "&:hover": {
                    backgroundColor:
                      alignment === "Approve"
                        ? themes.headLine
                        : themes.lightBrown,
                    color:
                      alignment === "Approve"
                        ? themes.whiteColor
                        : themes.headLine,
                  },
                }}
                onClick={() => {
                  setUpdateLeaveCard(true);
                  setSelectedComponent("pending");
                }}
              >
                Approve
              </ToggleButton>
              <ToggleButton
                value="History"
                sx={{
                  flex: 1,
                  textTransform: "capitalize",
                  borderRadius: !checkFirstLevelApproverPermission(
                    userScreenAccess?.module_details,
                    "Approve",
                    "Leaves"
                  )
                    ? "30px"
                    : "0px",
                  fontSize: 18,
                  fontWeight: 600,
                  border: "none",
                  color:
                    alignment === "History"
                      ? themes.whiteColor
                      : themes.headLine,
                  backgroundColor:
                    alignment === "History"
                      ? themes.headLine
                      : themes.lightBrown,
                  "&.Mui-selected": {
                    backgroundColor: themes.headLine,
                    color: themes.whiteColor,
                    "&:hover": {
                      backgroundColor: themes.headLine,
                      color: themes.whiteColor,
                    },
                    borderRadius: "30px",
                    "&.Mui-selected": {
                      borderRadius: "30px",
                    },
                  },
                  "&:hover": {
                    backgroundColor:
                      alignment === "History"
                        ? themes.headLine
                        : themes.lightBrown,
                    color:
                      alignment === "History"
                        ? themes.whiteColor
                        : themes.headLine,
                  },
                }}
                onClick={() => {
                  reCallMemberApi(true);
                  setSelectedComponent("approved");
                  setReloadApprovedData(true);
                }}
              >
                History
              </ToggleButton>
              {checkFirstLevelApproverPermission(
                userScreenAccess?.module_details,
                "Approve",
                "Leaves"
              ) ? (
                <ToggleButton
                  value="Apply Leave"
                  sx={{
                    flex: 1,
                    textTransform: "capitalize",
                    fontSize: 18,
                    borderRadius: "30px",
                    fontWeight: 600,
                    border: "none",
                    color:
                      alignment === "Apply Leave"
                        ? themes.whiteColor
                        : themes.headLine,
                    backgroundColor:
                      alignment === "Apply Leave"
                        ? themes.headLine
                        : themes.lightBrown,
                    "&.Mui-selected": {
                      backgroundColor: themes.headLine,
                      color: themes.whiteColor,
                      "&:hover": {
                        backgroundColor: themes.headLine,
                        color: themes.whiteColor,
                      },
                      borderRadius: "30px",
                      "&.Mui-selected": {
                        borderRadius: "30px",
                      },
                    },
                    "&:hover": {
                      backgroundColor:
                        alignment === "Apply Leave"
                          ? themes.headLine
                          : themes.lightBrown,
                      color:
                        alignment === "Apply Leave"
                          ? themes.whiteColor
                          : themes.headLine,
                    },
                    "&:focus": {
                      backgroundColor:
                        alignment === "Apply Leave"
                          ? themes.headLine
                          : themes.lightBrown,
                      color:
                        alignment === "Apply Leave"
                          ? themes.whiteColor
                          : themes.headLine,
                    },
                  }}
                  onClick={() => {
                    setReloadRejectedData(true);
                    setSelectedComponent("rejected");
                  }}
                >
                  Apply
                </ToggleButton>
              ) : null}
            </ToggleButtonGroup>
          </Mui.Box>
        </Mui.Grid>
        <Mui.Grid xs={0.2}></Mui.Grid>
        <Mui.Grid item xs={2.4} sx={{ padding: 1 }}>
          {selectedComponent === "pending" ||
          selectedComponent === "approved" ? (
            <CustomAutoComplete
              dataList={departmentData?.map((obj) => ({
                ...obj,
                label: obj.department_name,
              }))}
              selectedValue={departmentName}
              updateDataFunction={updateDepartmentName}
              placeHolder="Select department name"
              label="Select Department Name"
            />
          ) : null}
        </Mui.Grid>
        <Mui.Grid item xs={2.4} sx={{ padding: 1 }}>
          {selectedComponent === "approved" ? (
            <CustomAutoCompleteWithLogo
              dataList={membersData?.map((obj) => ({
                ...obj,
                label: obj?.user_name,
                image: obj?.image_url,
              }))}
              selectedValue={userName}
              updateDataFunction={updateUserName}
              placeHolder="Select employee name"
              label="Select User Name"
              showAvathar={showAutoCompleteAvathar}
              setShowAutoCompleteAvathar={setShowAutoCompleteAvathar}
            />
          ) : null}
        </Mui.Grid>
        <Mui.Grid item xs={2.5} sx={{ padding: 1 }}>
          {selectedComponent === "approved" ? (
            <DefaultMonthDateRangePicker
              handleStartDate={handleStartDate}
              showToday={true}
              triggerDate={true}
            />
          ) : null}
        </Mui.Grid>
      </Mui.Grid>
      <Mui.Grid container>
        <Mui.Grid
          xs={selectedComponent === "pending" ? 8.8 : 12}
          sx={{ justifyContent: "center" }}
        >
          {renderComponent()}
        </Mui.Grid>
        <Mui.Grid
          xs={selectedComponent === "pending" ? 0.2 : 0}
          sx={{
            borderRight: "4px solid black",
          }}
        ></Mui.Grid>
        <Mui.Grid xs={selectedComponent === "pending" ? 3 : 0}>
          {selectedComponent === "pending" ? (
            <LeavesCard
              updateLeaveCard={updateLeaveCard}
              setUpdateLeaveCard={setUpdateLeaveCard}
              departmentId={departmentId}
            />
          ) : null}
        </Mui.Grid>
      </Mui.Grid>
    </div>
  );
};
